import React from 'react';
import { Moon } from 'lucide-react';
export const Footer = () => {
  return <footer className="bg-navy-950 pt-10 pb-16 px-4 border-t border-navy-800" data-id="element-116">
      <div className="max-w-6xl mx-auto text-center" data-id="element-117">
        <div className="flex items-center justify-center space-x-2 text-gold-400 font-serif font-bold text-2xl mb-6" data-id="element-118">
          <Moon className="w-6 h-6" data-id="element-119" />
          <span data-id="element-120">MUNDO PRÁCTICO™</span>
        </div>

        <p className="text-gray-400 max-w-md mx-auto mb-2" data-id="element-121">
          El sistema de sueño infantil N°1 para familias argentinas con bebés de
          0 a 36 meses.
        </p>
        <p className="text-gray-500 italic mb-12" data-id="element-122">
          Porque criar a tu bebé no debería costarte todas las noches del año.
        </p>

        <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 text-sm text-gray-400 mb-12" data-id="element-123">
          <a href="mailto:mundopractico.oficial@gmail.com" className="hover:text-gold-400 transition-colors" data-id="element-124">
            📧 mundopractico.oficial@gmail.com
          </a>
          <a href="https://mundopractico.online" target="_blank" rel="noopener noreferrer" className="hover:text-gold-400 transition-colors" data-id="element-125">
            🌐 mundopractico.online
          </a>
        </div>

        <div className="border-t border-navy-800 pt-8 flex flex-col items-center" data-id="element-126">
          <p className="text-xs text-gray-600 mb-6" data-id="element-127">
            © Mundo Práctico™ 2026 — Todos los derechos reservados.
          </p>
          <p className="text-gold-500/50 font-serif italic text-lg" data-id="element-128">
            🌙 "La próxima madrugada puede ser diferente."
          </p>
        </div>
      </div>
    </footer>;
};